<template>
    <div class="TQ_padding_8px">

        <!-- table-->
        <div class="TQ_maxWidth_900px TQ_center">
            <table v-if="p_discountCoupons_byCouponId_c" class="TQ_width_100p  ">
                <tr class="TQ_bg_purple_lite TQ_text_20px TQ_text_capitalize">
                    <td>#</td>
                    <td>{{ass_strings.twoWords_createdDate[p_systemLangCode_e]}}</td>
                    <td>{{ass_strings.oneWord_name[p_systemLangCode_e]}}</td>
                    <td>{{ass_strings.oneWord_discount[p_systemLangCode_e]}}</td>
                    <td>{{ass_strings.oneWord_id[p_systemLangCode_e]}}</td>
                    <td>{{ass_strings.oneWord_status[p_systemLangCode_e]}}</td>
                </tr>

                <tr v-for="(discountCoupon_c, couponId_uid, index_n) in p_discountCoupons_byCouponId_c"
                    class="TQ_selectable"
                    :class="index_n%2 === 0 && 'TQ_bg_gray4'">
                    <td>{{index_n+1}}</td>
                    <td class="TQ_direction_rtl">{{format_date_YYYY_MM_DD_hh_mm_fs(discountCoupon_c.qbc_createdTime_t)}}</td>
                    <td>{{discountCoupon_c.qdc_couponCode_s}}</td>
                    <td>{{discountCoupon_c.qdc_discountPercentage_n}}%</td>
                    <td>{{discountCoupon_c.qdc_couponId_uid}}</td>
                    <td >
                        <tq-loader-container :p_show-loader_b="activeLoader_byCouponId_b[discountCoupon_c.qdc_couponId_uid]">
                            <div class="TQ_text_capitalize TQ_text_14px">
                                {{discountCoupon_c.qdc_active_b ? ass_strings.oneWord_active[p_systemLangCode_e] : ass_strings.oneWord_inactive[p_systemLangCode_e]}}
                            </div>
                            <tq-toggle-switch v-model="discountCoupon_c.qdc_active_b" @input="m_changeCouponStatus_f(discountCoupon_c.qdc_couponId_uid)"/>
                        </tq-loader-container>
                    </td>
                </tr>

            </table>

            <!-- btns -->
            <div class="TQ_align_end TQ_margin_top_8px">
                <div @click="popup_show_vb.val=true"
                     v-if="co_showAddBtn_n"
                     class="TQ_padding_8px TQ_inline TQ_bg_green  TQ_borderRadius  TQ_box_shadow TQ_clickable TQ_width_100px TQ_textColor_white TQ_text_capitalize TQ_center TQ_borderBox">
                    {{ass_strings.oneWord_new[p_systemLangCode_e]}}
                </div>
            </div>
        </div>


        <!-- popup -->
        <tq-popup :show="popup_show_vb" max-width="400px" padding="0" :show-close-btn="true">


            <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_capitalize TQ_text_20px">
                {{ ass_strings.twoWords_discountCoupon[p_systemLangCode_e] }}
            </div>

            <div class="TQ_padding_16px">


                <!-- discount code-->
                <div class="TQ_width_150px TQ_inline">
                    <div class="TQ_align_initial TQ_text_bold ">
                        {{ ass_strings.oneWord_code[p_systemLangCode_e] }}
                    </div>

                    <fc-error-input
                        p_input-class_s="TQ_center TQ_padding_4px TQ_width_150px TQ_borderBox TQ_align_initial"
                        :p_input-type_s="enum_inputType.text_s"
                        :p_val_o="new_couponCode_s"
                        :p_error_s="co_new_error_code_s"
                        :p_placeholder_s="ass_strings.oneWord_code[p_systemLangCode_e]"
                        :pe_input_f="val => new_couponCode_s = val"/>

                    <div class="TQ_align_end TQ_text_12px TQ_text_capitalize" :class="co_new_error_code_s && 'TQ_textColor_red'">
                        {{ass_strings.twoWords_3letters[p_systemLangCode_e]}}
                    </div>

                </div>

                <!-- space -->
                <div class="TQ_padding_4px TQ_inline"></div>

                <!-- Discount %-->
                <div class="TQ_width_150px TQ_inline">
                    <div class="TQ_align_initial TQ_text_bold TQ_text_capitalize">
                        {{ass_strings.oneWord_discount[p_systemLangCode_e]}} (%)
                    </div>

                    <fc-error-input
                        p_input-class_s="TQ_center TQ_padding_4px TQ_width_150px TQ_borderBox TQ_align_initial"
                        :p_input-type_s="enum_inputType.number_s"
                        :p_max_n="maxDiscountPercentage"
                        :p_min_n="minDiscountPercentage"
                        :p_val_o="new_discountPercentage_n"
                        :p_error_s="co_new_error_percentage_s"
                        :pe_input_f="val => new_discountPercentage_n = val"/>

                    <div class="TQ_align_end TQ_text_12px TQ_text_capitalize" :class="co_new_error_percentage_s && 'TQ_textColor_red'">
                        [{{ minDiscountPercentage}}%, {{maxDiscountPercentage}}%]
                    </div>

                </div>


            </div>


            <div class="TQ_padding_8px TQ_border_top TQ_align_end">

                <tq-loader-button :show-loader="showBtnLoader_b">

                    <tq-btn-approve
                        :system-lang-code="p_systemLangCode_e"
                        :popup-text="ass_strings.question_newDiscountCoupon"
                        :approve-cb="m_createNewQuestDiscountCoupon_f ">
                        <div class="TQ_inline  TQ_padding_8px TQ_borderRadius TQ_clickable TQ_box_shadow TQ_bg_green TQ_width_64px TQ_center">
                            {{ ass_strings.oneWord_approve[p_systemLangCode_e] }}
                        </div>
                    </tq-btn-approve>

                </tq-loader-button>


            </div>



        </tq-popup>
    </div>
</template>

<script>
import {
    validator_enum_fb,
    validator_null_fb,
    validator_objClass_fb
} from "../../../../../functions/src/shareCode/Share_S_Validator";
import {FB_QuestDiscountCoupon, FB_UserData} from "../../../../../functions/src/shareCode/Share_S_Classes";
import {
    enum_featuresMinPoints,
    enum_inputType,
    enum_langCodes,
    enum_moreInfo_featuresIds_s
} from "../../../../../functions/src/shareCode/Share_S_Enum";
import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
import TqPopup from "@/components/basic/TqPopup";
import Table from "@/components/basic/Table";
import TqTable from "@/components/basic2/TqTable";
import TqToggleSwitch from "@/components/basic/TqToggleSwitch";
import FcErrorInput from "@/components/basic/TqErrorInput";
import {notification_notify2} from "@/scripts/S_Notification";
import TqLoaderButton from "@/components/basic2/TqLoaderButton";
import TqBtnApprove from "@/components/basic2/TqBtnApprove";
import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
import {format_date_YYYY_MM_DD_hh_mm_fs} from "../../../../../functions/src/shareCode/Share_S_Format";

export default {
    name: "c_Creator_EditQuests_Item_DiscountCoupons",
    components: {TqLoaderContainer, TqBtnApprove, TqLoaderButton, FcErrorInput, TqToggleSwitch, TqTable, Table, TqPopup},
    props:{
        p_systemLangCode_e:{
            type: String,
            require: true,
            validator(val){
                return validator_enum_fb(enum_langCodes, val)
            }
        },
        p_discountCoupons_byCouponId_c:{
            require: true,
            validator(val){
                return validator_null_fb(val) || validator_objClass_fb(val, FB_QuestDiscountCoupon)
            }
        },
        p_creatorData_c:{
            type: FB_UserData,
            require: true
        },
        pe_refreshDiscountCoupons_f:{
            require: true,
            type: Function
        },
        pe_createNewDiscountCoupon_f:{
            require: true,
            type: Function
        },
        pe_updateCouponStatus_f:{
            require: true,
            type: Function
        },
    },
    data(){
        return {
            new_couponCode_s : '',
            new_discountPercentage_n : 10,
            minDiscountPercentage : 5,
            maxDiscountPercentage : 30,

            newDiscountCoupon_percentage_n : 0,
            newDiscountCoupon_code_s : '',

            popup_show_vb: {val : false},
            showBtnLoader_b: false,
            activeLoader_byCouponId_b : {},

            ass_strings : ass_strings,
            enum_inputType : enum_inputType,

            format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs
        }
    },
    computed:{
        co_showAddBtn_n(){
            if(this.p_discountCoupons_byCouponId_c == null){
                return true
            }

            let discountCouponNum_n = Object.keys(this.p_discountCoupons_byCouponId_c).length

            return discountCouponNum_n < 20
        },
        co_new_error_code_s(){
            if(this.new_couponCode_s.length < 3){
                return ass_strings.oneWord_error[this.p_systemLangCode_e]
            }
            return null
        },
        co_new_error_percentage_s(){
            if(this.new_discountPercentage_n > this.maxDiscountPercentage){
                return ass_strings.oneWord_error[this.p_systemLangCode_e]
            }else if(this.new_discountPercentage_n < this.minDiscountPercentage){
                return ass_strings.oneWord_error[this.p_systemLangCode_e]
            }
            return null
        },
        co_discountCouponsIds_byCodes_uid(){
            let ans_o ={}
            for(let couponCodeId_uid in this.p_discountCoupons_byCouponId_c){
                ans_o[this.p_discountCoupons_byCouponId_c[couponCodeId_uid].qdc_couponCode_s] = couponCodeId_uid
            }
            return ans_o
        }
    },
    methods: {
        m_createNewQuestDiscountCoupon_f() {

            if(this.co_new_error_code_s || this.co_new_error_percentage_s){
                notification_notify2({title_s: ass_strings.oneWord_error[this.p_systemLangCode_e]})
                return
            }

            if(this.co_discountCouponsIds_byCodes_uid[this.new_couponCode_s]){
                notification_notify2({title_s: ass_strings.oneWord_error[this.p_systemLangCode_e]})
                return
            }

            this.showBtnLoader_b = true
            this.pe_createNewDiscountCoupon_f(this.new_couponCode_s,this.new_discountPercentage_n, (questDiscountCoupon_c) => {
                this.$set(this.p_discountCoupons_byCouponId_c, questDiscountCoupon_c.qdc_couponId_uid, questDiscountCoupon_c)
                this.showBtnLoader_b = false
                this.popup_show_vb.val = false
            })
        },
        m_changeCouponStatus_f(couponId_uid){
            this.$set(this.activeLoader_byCouponId_b, couponId_uid, true)

            this.pe_updateCouponStatus_f(this.p_discountCoupons_byCouponId_c[couponId_uid], ()=> {
                this.activeLoader_byCouponId_b[couponId_uid] = false
            })

        }
    },
    mounted() {
        this.pe_refreshDiscountCoupons_f()
    }
}
</script>

<style scoped lang="scss">
table{
    background: white;
    border: 1px solid black;

    td{
        padding: 8px;
        border: 1px solid black;
    }

}
</style>